import React from 'react';
import {
  Card,
  CardTitle,
  Button,
  CardBody,
  Typography,
  CardActions,
  Alert,
} from '@one-thd/sui-atomic-components';
import proptypes from 'prop-types';
const { objectOf, shape, bool } = proptypes;
import { PAYMENTS_PATH } from '../../constants/links';
import { getCardImagePath } from '../../utils/helpers';

export const PaymentDataCard = ({ payment, isB2B }) => {
  const {
    cardNickName,
    cardBrand,
    cardBrandType,
    cardLast4,
    cardExpiryMonth,
    cardExpiryYear,
    isAuthorizeFlag,
    t2cStatus,
    isCardExpired,
    cardStatus,
  } = payment;

  const isCardInactive = cardStatus?.toLowerCase() === 'inactive';
  const shouldUpdateCardInformation = isCardExpired || isCardInactive;

  const onViewAllClick = () => {
    // analytics event
    window.LIFE_CYCLE_EVENT_BUS.trigger('payment-method-card-view-all.click');
  };
  return (
    <Card grow PaperProps={{ className: 'sui-flex sui-h-full' }} data-component="PaymentMethodCardPaymentDataCard">
      <CardTitle
        header={(
          <Typography height="tight" variant="h3" weight="bold">
            Cards & Accounts
          </Typography>
        )}
        disableActionSpacing
        action={(
          <Button variant="text" href={PAYMENTS_PATH} onClick={onViewAllClick}>
            View All
          </Button>
        )}
        subheader={(
          <Typography variant="body-lg" color="subtle">
            Default Payment Method
          </Typography>
        )}
      />
      <CardBody>
        <Typography variant="h4">{cardNickName}</Typography>
        <div className="sui-flex sui-flex-wrap sui-mt-2 sui-mb-3 sui-items-center">
          <img
            data-testid="CardBrandLogo"
            width={80}
            height="auto"
            className="sui-inline-block sui-mr-4"
            src={getCardImagePath(cardBrand, cardBrandType, isB2B)}
            alt="Credit card logo"
          />
          <div className="sui-mr-4">
            <Typography variant="body-lg" color="subtle">
              ****{cardLast4}
            </Typography>
          </div>
          {cardExpiryMonth && cardExpiryYear && (
            <Typography variant="body-lg" color="subtle">
              {`Exp ${cardExpiryMonth}/${cardExpiryYear.slice(-2)}`}
            </Typography>
          )}
        </div>
        {isB2B && (
          <>
            <Typography>{isAuthorizeFlag && 'Phone Authorized'}</Typography>
            <Typography>{t2cStatus === 'enrolled' && 'Text2Confirm Authorized'}</Typography>
          </>
        )}
        {isCardExpired && (
          <div className="sui-mt-4">
            <Alert status="error">Your card is expired.</Alert>
          </div>
        )}
        {isCardInactive && (
          <div className="sui-mt-4">
            <Alert status="error">Your card is inactive.</Alert>
          </div>
        )}
        {shouldUpdateCardInformation && (
          <Typography>
            Update your card information or set up a new default payment method for easy checkout.
          </Typography>
        )}
      </CardBody>
      {shouldUpdateCardInformation && (
        <CardActions>
          <Button fullWidth variant="secondary" href={PAYMENTS_PATH}>
            Update Card Information
          </Button>
        </CardActions>
      )}
    </Card>
  );
};

PaymentDataCard.displayName = 'PaymentDataCard';

PaymentDataCard.propTypes = {
  payment: objectOf(shape),
  isB2B: bool,
};

PaymentDataCard.defaultProps = {
  payment: {},
  isB2B: false
};